import userApiClient from '../../../api/user';
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from '../../../hooks/useKlydoMutation';

const useSendKlydoToClockMutation = (
  options?: UseKlydoMutationOptions<void, { klydoId: string }>,
) => {
  return useKlydoMutation({
    mutationKey: ['send-klydo-to-clock'],
    mutationFn: ({ klydoId }) => userApiClient.sendKlydoToClock(klydoId),
    ...options,
  });
};

export default useSendKlydoToClockMutation;
